import React, { useContext, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

const Topnav = () => {
    
    const handleSidebarToggle = () => {
        document.body.classList.toggle("sidebar-toggled");
        const sidebar = document.getElementById("accordionSidebar");
        if (sidebar) {
            sidebar.classList.toggle("toggled");
        }
    };
    const { currentUser } = useContext(AuthContext);
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = useCallback((event) => {
        event.preventDefault();
        logout();
        navigate('/admin/system-login'); // Use navigate instead of window.location
    }, [logout, navigate]);

    return (
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            {/* Sidebar Toggle Button (Mobile) */}
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle" onClick={handleSidebarToggle}>
                <i className="fa fa-bars"></i>
            </button>

            {/* Search Bar */}
            <form className="d-none d-sm-inline-block form-inline me-auto ms-md-3 my-2 my-md-0 mw-100 navbar-search">
                <div className="input-group">
                    <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..." />
                    <button className="btn btn-primary" type="button">
                        <i className="fas fa-search fa-sm"></i>
                    </button>
                </div>
            </form>

            {/* Navbar Right Section */}
            <ul className="navbar-nav ms-auto">
                {/* Alerts Dropdown */}
                <li className="nav-item dropdown no-arrow mx-1">
                    <a className="nav-link dropdown-toggle" href="/" id="alertsDropdown" role="button" data-bs-toggle="dropdown">
                        <i className="fas fa-bell fa-fw"></i>
                        <span className="badge bg-danger badge-counter">3+</span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end shadow animated--grow-in" aria-labelledby="alertsDropdown">
                        <li><h6 className="dropdown-header">Alerts Center</h6></li>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center text-decoration-none" to="/">
                                <div className="me-3">
                                    <div className="icon-circle bg-primary">
                                        <i className="fas fa-file-alt text-white"></i>
                                    </div>
                                </div>
                                <div>
                                    <div className="small text-gray-500">December 12, 2023</div>
                                    <span className="fw-bold">A new monthly report is ready!</span>
                                </div>
                            </Link>
                            <Link className="dropdown-item d-flex align-items-center text-decoration-none" to="/">
                                <div className="me-3">
                                    <div className="icon-circle bg-primary">
                                        <i className="fas fa-file-alt text-white"></i>
                                    </div>
                                </div>
                                <div>
                                    <div className="small text-gray-500">December 12, 2023</div>
                                    <span className="fw-bold">A new monthly report is ready!</span>
                                </div>
                            </Link>
                        </li>
                        <li><Link className="dropdown-item text-center small text-gray-500" to="/">Show All Alerts</Link></li>
                    </ul>
                </li>

                {/* Messages Dropdown */}
                <li className="nav-item dropdown no-arrow mx-1">
                    <a className="nav-link dropdown-toggle" href="/" id="messagesDropdown" role="button" data-bs-toggle="dropdown">
                        <i className="fas fa-envelope fa-fw"></i>
                        <span className="badge bg-danger badge-counter">7</span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end shadow animated--grow-in" aria-labelledby="messagesDropdown">
                        <li><h6 className="dropdown-header">Message Center</h6></li>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center text-decoration-none" to="/">
                                <div className="dropdown-list-image me-3">
                                    <img className="rounded-circle" src="/img/undraw_profile_1.svg" alt="..." />
                                    <div className="status-indicator bg-success"></div>
                                </div>
                                <div>
                                    <div className="text-truncate">Hi there! I need your help...</div>
                                    <div className="small text-gray-500">Emily Fowler · 58m</div>
                                </div>
                            </Link>
                            <Link className="dropdown-item d-flex align-items-center text-decoration-none" to="/">
                                <div className="dropdown-list-image me-3">
                                    <img className="rounded-circle" src="/img/undraw_profile_1.svg" alt="..." />
                                    <div className="status-indicator bg-success"></div>
                                </div>
                                <div>
                                    <div className="text-truncate">Hi there! I need your help...</div>
                                    <div className="small text-gray-500">Emily Fowler · 58m</div>
                                </div>
                            </Link>
                        </li>
                        <li><Link className="dropdown-item text-center small text-gray-500" to="/">Read More Messages</Link></li>
                    </ul>
                </li>

                {/* User Profile Dropdown */}
                <div className="topbar-divider d-none d-sm-block"></div>
                <li className="nav-item dropdown no-arrow">
                    <a className="nav-link dropdown-toggle" href="/" id="userDropdown" role="button" data-bs-toggle="dropdown">
                        <span className="me-2 d-none d-lg-inline text-gray-600 small">{currentUser?.user_name}</span>
                        <img className="img-profile rounded-circle" src={currentUser?.profileImage || "/img/undraw_profile.svg"} alt="Profile" />
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end shadow animated--grow-in" aria-labelledby="userDropdown">
                        <li>
                            <Link className="dropdown-item text-decoration-none" to="/profile">
                                <i className="fas fa-user fa-sm fa-fw me-2 text-gray-400"></i> Profile
                            </Link>
                        </li>
                        <li>
                            <Link className="dropdown-item text-decoration-none" to="/settings">
                                <i className="fas fa-cogs fa-sm fa-fw me-2 text-gray-400"></i> Settings
                            </Link>
                        </li>
                        <li>
                            <Link className="dropdown-item text-decoration-none" to="/activity">
                                <i className="fas fa-list fa-sm fa-fw me-2 text-gray-400"></i> Activity Log
                            </Link>
                        </li>
                        <li><div className="dropdown-divider"></div></li>
                        <li>
                            <button className="dropdown-item" type="button" onClick={handleLogout}>
                                <i className="fas fa-sign-out-alt fa-sm fa-fw me-2 text-gray-400"></i> Logout
                            </button>
                            {/* <button className="dropdown-item" type="button" data-bs-toggle="modal" data-bs-target="#logoutModal">
                                <i className="fas fa-sign-out-alt fa-sm fa-fw me-2 text-gray-400"></i> Logout
                            </button> */}
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    );
};

export default Topnav;
